import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AddContentPage.css';
import cx from 'classnames';
import AddContentPageForm from '../../../../components/SiteAdmin/ContentPage/AddContentPageForm';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../../locale/messages';
import moment from 'moment';

export class AddContentPage extends Component {

    render() {
        const { title } = this.props
        const localNow = moment().format('YYYY-MM-DDTHH:mm');
        return (
            <div className={s.root}>
              <div className={s.container}>
               <div className={cx(s.heading, 'textAlignRightRTL')}>
                <FormattedMessage {...messages.addPageDetails} />
                </div>
                <div>
                  <AddContentPageForm initialValues={{ startDate: localNow }} />
                </div>
              </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default compose(
    withStyles(s),
    connect(mapStateToProps, mapDispatchToProps)
)(AddContentPage)
